import {createBrowserRouter} from "react-router-dom";
import RequireAuth from "./hoc/RequireAuth";
import Main from "./pages/Main";
import DeviceList from "./pages/DeviceList";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Analytics from "./pages/Analytics";
import {
    ADMIN_ROUTE,
    ANALYTICS_ROUTE,
    AUTH_ROUTE,
    DASHBOARD_ROUTE,
    MAIN_ROUTE,
    OTHER_ROUTE,
    THINGS_ROUTE
} from "./utils/consts";

export const router = createBrowserRouter([
    {
        element: <RequireAuth><Main/></RequireAuth>,
        path: MAIN_ROUTE,
        children: [
            {
                path: OTHER_ROUTE,
                element: <RequireAuth><Main/></RequireAuth>
            },
            {
                path: THINGS_ROUTE,
                element: <RequireAuth><DeviceList/></RequireAuth>,
            },
            {
                path: DASHBOARD_ROUTE,
                element: <RequireAuth><Dashboard/></RequireAuth>,
            },
            {
                path: ANALYTICS_ROUTE,
                element: <RequireAuth><Analytics/></RequireAuth>,
            },
            {
                path: ADMIN_ROUTE,
                element: <RequireAuth><Admin/></RequireAuth>,
            },
        ],
    },
    {
        element: <Auth/>,
        path: AUTH_ROUTE,
    }
]);